module.exports = __webpack_public_path__ + "static/bg-1984-1422578b1c35e07a30de0e1ab807d2c7.png";